import { render, staticRenderFns } from "./SchemaPreviewForm.vue?vue&type=template&id=14d876f2&"
import script from "./SchemaPreviewForm.vue?vue&type=script&lang=js&"
export * from "./SchemaPreviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports